module.exports = __webpack_public_path__ + "static/5-5c290ffd9ef38ab8921598264006a16b.jpg";